const SECOND = 1000;
const DURATION = 90 * SECOND;

class SleepCounter {
  constructor() {
    this._current_s = 0;
  }

  start() {
    this._interval = setInterval(() => {
      this._current_s += 1 * SECOND;

      if (this._current_s >= DURATION) {
        this._func();
        this._current_s = 0;
      }
    }, 1000);
  }

  reset() {
    this._current_s = 0;
  }

  stop() {
    clearInterval(this._interval);
  }

  on(func) {
    this._func = func || (() => {});
  }
}

export default SleepCounter;
